module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_2.5d6126b4.jpg";